
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0zGqi5jDjQboenwaobVGfDp96qlGrDWRTneWf2XigiYMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexLIQPdQLbI_Mf7azRkAy3guOfkaMhn5R0BC6Q3geQaW8Meta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchs_45UPPil67UGEDYnsLdbvKsEys1M_45P58qNc0aSrgZA3gMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexiGKL_t11KQYPDJ1xoHaRlujI5tF1E5vrOwFlPWBGx_45YMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Ko33CBBNjFzg8sim_45gzKRULDNRNqtXXEx0PxeiFmRNQMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexf1z2PjjBRr0YQZzpuUCoPILSkG__45LNOuJMevanybY8IMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93wXEiCfi4yjnnJIMA3XTc1OlZYeosBVXtakWO7ceLJYYMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexF6512DXPG5i7JsPQDZzExnOVFQVRYN2ArCoVniLGraQMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93nB1msEWSKn4l5GUbwibIFHgoz9SXOjx35ZyPKYWc56UMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexgZqt17dQTINE3axTtxmDa_6RArlqSqH_KdnqgIurSpAMeta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPMareoBzNjFsg_QT4RNUI9EtPcUBRKl3iur0FjXIVI4Meta } from "/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexf1z2PjjBRr0YQZzpuUCoPILSkG__45LNOuJMevanybY8IMeta || {},
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexF6512DXPG5i7JsPQDZzExnOVFQVRYN2ArCoVniLGraQMeta || {},
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexgZqt17dQTINE3axTtxmDa_6RArlqSqH_KdnqgIurSpAMeta || {},
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPMareoBzNjFsg_QT4RNUI9EtPcUBRKl3iur0FjXIVI4Meta || {},
    component: () => import("/codebuild/output/src695222090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]